'use client'

import { useQuickLinks } from '@/hooks/useQuickLinks'

import styles from './TopBar.module.scss'
import { TopBarQuickLink } from './TopBarQuickLink/TopBarQuickLink'

export const TopBar = () => {
  const quickLinks = useQuickLinks()

  return (
    <ul className={styles.container}>
      {quickLinks.map((item, i) => (
        <TopBarQuickLink item={item} key={i} styles={styles} />
      ))}
    </ul>
  )
}
